import React, { FC } from 'react'
import { Flex, Text, PrimaryButton } from '@moonpig/launchpad-components'
import { IconSystemGroup } from '@moonpig/launchpad-assets'
import { Item } from '@radix-ui/react-dropdown-menu'
import { redirect } from '@moonpig/web-core-routing'
import { useStoreId } from '@moonpig/web-core-stores'
import { useFindLocaleText } from '../../../text-localisation'

const ICON_SIZE = 24

type Props = {
  inDropdownMenu?: boolean
}

export const RecipientSignInPrompt: FC<Props> = ({
  inDropdownMenu = false,
}) => {
  const storeId = useStoreId()
  const localiseText = useFindLocaleText()
  const signInLabel = localiseText('find.sign_in')

  const handleSignIn = () => {
    const returnUrl = new URL(window.location.href)
    returnUrl.searchParams.set('showRecipients', 'true')

    redirect({
      path: `/${storeId}/account/login/`,
      returnUrl: returnUrl.pathname + returnUrl.search,
    })
  }

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={12}
      py={{ xs: 6, md: 10 }}
    >
      <IconSystemGroup width={ICON_SIZE} height={ICON_SIZE} aria-hidden />
      <Text textAlign="center">
        {localiseText('find.recipients_filter.sign_in_message')}
      </Text>
      {inDropdownMenu ? (
        <Item onSelect={handleSignIn} asChild>
          <PrimaryButton>{signInLabel}</PrimaryButton>
        </Item>
      ) : (
        <PrimaryButton onClick={handleSignIn}>{signInLabel}</PrimaryButton>
      )}
    </Flex>
  )
}
